import React from "react";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { TrustBar } from "@/components/sections/TrustBar";
import { Insight } from "@/components/sections/Insight";
import { CoreProducts } from "@/components/sections/CoreProducts";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { AICoach } from "@/components/sections/AICoach";
import { Dashboard } from "@/components/sections/Dashboard";
import { NRIStack } from "@/components/sections/NRIStack";
import { ShreeRound } from "@/components/sections/ShreeRound";
import { Gamification } from "@/components/sections/Gamification";
import { ShreeSeva } from "@/components/sections/ShreeSeva";
import { Diaspora } from "@/components/sections/Diaspora";
import { Testimonials } from "@/components/sections/Testimonials";
import { Transparency } from "@/components/sections/Transparency";
import { Pricing } from "@/components/sections/Pricing";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { Footer } from "@/components/sections/Footer";

export default function LandingPage() {
  return (
    <main className="relative">
      <Navbar />
      <Hero />
      <TrustBar />
      <Insight />
      <CoreProducts />
      <HowItWorks />
      <AICoach />
      <Dashboard />
      <NRIStack />
      <ShreeRound />
      <Gamification />
      <ShreeSeva />
      <Diaspora />
      <Testimonials />
      <Transparency />
      <Pricing />
      <FinalCTA />
      <Footer />
    </main>
  );
}
